import { Navigate, Outlet } from "react-router-dom";
import { hasRole } from "../../utils/auth";
import type { UserRole } from "../../utils/auth";

interface RoleProtectedRouteProps {
  requiredRole: UserRole;
}

/**
 * 특정 Role을 가진 사용자만 접근할 수 있는 라우트를 위한 컴포넌트
 * admin은 모든 페이지에 접근 가능
 * student는 지정된 페이지만 접근 가능
 * 권한이 없는 사용자는 홈 페이지로 리다이렉트됩니다.
 */
const RoleProtectedRoute = ({ requiredRole }: RoleProtectedRouteProps) => {
  // admin은 모든 페이지에 접근 가능
  if (hasRole("admin")) {
    return <Outlet />;
  }

  // student는 지정된 페이지만 접근 가능
  if (requiredRole === "student" && hasRole("student")) {
    return <Outlet />;
  }

  return <Navigate to="/my_exams" replace />;
};

export default RoleProtectedRoute;
